<template>
    <div class="reg-temp-content-area main-content-height p-3">
        <div class="superadmin-dashboard-area edit-area">
            <div class="row">
                <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="card mb-4">
                        <div class="card-body">
                            <div class="registered-product-item w-half">
                                <router-link :to="{name: 'DistributorRegisteredProducts'}" class="mb-3 inline-block"
                                    ><i class="fas fa-long-arrow-alt-left"></i> Back</router-link
                                >
                                <h3 class="mb-4">Add product</h3>
                                <ul>
                                    <serial-and-model :data="form" />
                                    <li>
                                        <span class="semibold">Date purchased</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.date_of_purchase"
                                                :typeable="false"
                                                :full-month-name="true"
                                                class="input"
                                                id="cdate"
                                                :format="'yyyy-MM-dd'"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="purchaseDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Installation date</span>
                                        <span>
                                            <vuejs-datepicker
                                                initial-view="year"
                                                maximum-view="year"
                                                v-model="form.installation_date"
                                                :typeable="false"
                                                :full-month-name="true"
                                                :format="'yyyy-MM-dd'"
                                                class="input"
                                                id="install_date"
                                                placeholder="YYYY-MM-DD"
                                                :disabled-dates="installationDisabledDates"
                                            ></vuejs-datepicker>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Place of purchase</span>
                                        <span><input type="text" v-model="form.place_of_purchase" /></span>
                                    </li>

                                    <li class="border-b-1">
                                        <file-uploader label="Upload proof of purchase" id="proof_of_purchase" :form.sync="form" />
                                    </li>

                                    <li>
                                        <span class="semibold">Installation status</span>
                                        <span class="mt-1 coc-radio d-flex flex-column cursor-pointer">
                                            <label class="mr-2 font-normal" for="with_coc">
                                                <input
                                                    id="with_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="with_coc"
                                                    name="installation_compliance"
                                                />
                                                Installed with COC
                                            </label>
                                            <label class="mr-2 font-normal" for="without_coc">
                                                <input
                                                    id="without_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="without_coc"
                                                    name="installation_compliance"
                                                />
                                                Installation delayed
                                            </label>
                                            <label class="mr-2 font-normal" for="no_coc">
                                                <input
                                                    id="no_coc"
                                                    type="radio"
                                                    class="w-auto"
                                                    v-model="form.installation_compliance"
                                                    value="no_coc"
                                                    name="installation_compliance"
                                                />
                                                No COC
                                            </label>
                                        </span>
                                    </li>
                                    <li>
                                        <ul v-show="form.installation_compliance == 'with_coc'">
                                            <li>
                                                <span class="semibold">Coc number</span> <span> <input type="text" v-model="form.coc_number" /></span>
                                            </li>
                                            <li class="border-b-1">
                                                <file-uploader label="Upload coc certificate" id="coc_certificate" :form.sync="form" />
                                            </li>
                                        </ul>
                                    </li>
                                    <!-- <li>
                                        invoice number: <span> <input type="text" v-model="form.invoice_number" /></span>
                                    </li> -->

                                    <li>
                                        <span class="semibold">Reseller</span>
                                        <span>
                                            <vue-autosuggest
                                                :suggestions="resellerSuggestions"
                                                :input-props="{class: 'form-control', id: 'autosuggest_soldto_input', placeholder: 'Search reseller'}"
                                                @input="onChangeReseller"
                                                @selected="selectResellerHandler"
                                                @click="onChangeReseller"
                                                :getSuggestionValue="resellerSuggestionsValue"
                                            >
                                                <template slot-scope="{suggestion}">
                                                    <span class="my-suggestion-item">{{
                                                        suggestion.item.company ? suggestion.item.company : suggestion.item.email
                                                    }}</span>
                                                </template>
                                            </vue-autosuggest>
                                        </span>
                                    </li>

                                    <li>
                                        <span class="semibold">Customer</span>
                                        <span>
                                            <vue-autosuggest
                                                :suggestions="customerSuggestions"
                                                :input-props="{
                                                    class: 'form-control',
                                                    id: 'autosuggest_soldto_customer_input',
                                                    placeholder: 'Search customer'
                                                }"
                                                @input="onChangeCustomer"
                                                @selected="selectCustomerHandler"
                                                @click="onChangeCustomer"
                                                :getSuggestionValue="customerSuggestionsValue"
                                            >
                                                <template slot-scope="{suggestion}">
                                                    <span class="my-suggestion-item">{{ suggestion.item.fname + ' ' + suggestion.item.lname }}</span>
                                                </template>
                                            </vue-autosuggest>
                                        </span>
                                    </li>

                                    <!-- <li>sold to: <span>
                      <vue-autosuggest
                        :suggestions="soldToSuggestions"
                        :input-props="{class:'form-control', id:'autosuggest_soldto_input', placeholder:'Search Customer'}"
                        @input="onChangeSoldTo"
                        @selected="selectSoldToHandler"
                        @click="onChangeSoldTo"
                        :getSuggestionValue="soldToSuggestionsValue"
                        >  
                        <template slot-scope="{suggestion}">
                          <span class="my-suggestion-item">{{ suggestion.item.company ? suggestion.item.company :  suggestion.item.fname + ' - ' + suggestion.item.email }}</span>
                        </template>
                      </vue-autosuggest>
                      </span>
                      <p class="mt-3"><em>Can't find ? <router-link :to="{ name: 'DistributorCustomerAdd', query: { redirect: 'DistributorRegisteredProductAdd' }}">Add new customer</router-link></em></p>
                    </li> -->
                                </ul>
                                <button class="btn btn-primary mt-3" @click.prevent="registerProduct()">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Env from '@/env';
import AuthApis from '@/controllers/AuthApis';
import Helpers from '@/helpers/index';
import {VueAutosuggest} from 'vue-autosuggest';
import {mapGetters} from 'vuex';
import moment from 'moment';

export default {
    components: {
        VueAutosuggest
    },
    name: 'customerRegProductAdd',
    data() {
        return {
            resellerObj: {},
            resellerSuggestions: [
                {
                    data: []
                }
            ],

            customerObj: {},
            customerSuggestions: [
                {
                    data: []
                }
            ],

            form: {
                hasOrderNumber: false,
                product_model: '',
                serial_number: '',
                sku_number: '',
                order_number: '',
                sku_with_serial_number: '',
                place_of_purchase: '',
                date_of_purchase: '',
                installation_date: '',
                installation_compliance: 'with_coc',
                coc_number: '',
                coc_certificate: {
                    incoming_url: '',
                    url: '',
                    file: '',
                    name: '',
                    type: '',
                    size: ''
                },
                invoice_number: '',
                // purchased_from: '',
                reseller_id: '',
                customer_id: '',
                proof_of_purchase: {
                    incoming_url: '',
                    url: '',
                    name: '',
                    type: '',
                    size: ''
                }
            }
        };
    },

    watch: {
        // 'form.date_of_purchase': {
        //     handler(newVal) {
        //         if (this.form.installation_date && newVal && this.form.installation_date < newVal) {
        //             this.form.installation_date = null;
        //         } else if (this.form.installation_date && !newVal) {
        //             this.form.installation_date = null;
        //         }
        //     },
        //     deep: true
        // },
        // 'form.installation_date': {
        //     handler(newVal) {
        //         if (this.form.date_of_purchase && newVal && this.form.date_of_purchase > newVal) {
        //             this.form.date_of_purchase = null;
        //         } else if (this.form.date_of_purchase && !newVal) {
        //             this.form.date_of_purchase = null;
        //         }
        //     },
        //     deep: true
        // }
    },

    computed: {
        purchaseDisabledDates() {
            let disabled = {from: new Date()};
            if (this.form.installation_date) {
                const dayAfterInstall = new Date(this.form.installation_date);
                dayAfterInstall.setDate(dayAfterInstall.getDate());
                disabled.from = dayAfterInstall;
            }
            return disabled;
        },
        installationDisabledDates() {
            let disabled = {from: new Date()};

            if (this.form.date_of_purchase) {
                const dayBeforePurchase = new Date(this.form.date_of_purchase);
                dayBeforePurchase.setDate(dayBeforePurchase.getDate());
                disabled.to = dayBeforePurchase;
            }

            return disabled;
        }
    },

    methods: {
        /**
         * Register product */

        async registerProduct() {
            const url = `${Env.baseUrl}/distributor/reg-product/create`;
            this.form.sku_with_serial_number = Helpers.getFullSerialNumber(this.form);
            this.form.installation_date = this.form.installation_date ? moment(this.form.installation_date).format('YYYY-MM-DD') : '';
            this.form.date_of_purchase = this.form.date_of_purchase ? moment(this.form.date_of_purchase).format('YYYY-MM-DD') : '';
            if (this.form.date_of_purchase && this.form.installation_date && this.form.installation_date < this.form.date_of_purchase) {
                return this.$toasted.global.error({
                    message: 'Installation date cannot be before date of purchase.'
                });
            }
            this.spinner(true);
            let formData = new FormData();
            for (let key in this.form) {
                if (key != 'coc_certificate' && key != 'proof_of_purchase') {
                    formData.append(key, this.form[key]);
                }
            }
            if (this.form.coc_certificate.file) {
                formData.append('coc_certificate', this.form.coc_certificate.file);
            }

            if (this.form.proof_of_purchase.file) {
                formData.append('proof_of_purchase', this.form.proof_of_purchase.file);
            }

            AuthApis.postApi(url, formData)
                .then((res) => {
                    this.spinner(false);
                    this.$toasted.global.success({
                        message: 'Successfully added.'
                    });
                    this.$router.push({name: 'DistributorRegisteredProducts'});
                })
                .catch((err) => {
                    this.spinner(false);
                    this.$toasted.global.error({
                        message: err.response.data.errors[0]
                    });
                });
        },

        /**
         *
         * On change Reseller
         */
        onChangeReseller: _.debounce(function (searchtext) {
            if (searchtext == null) {
                searchtext = document.getElementById('autosuggest_soldto_input').value;
            }

            // suggest dropdown based on company name
            this.form.reseller_id = '';
            const url = `${Env.baseUrl}/distributor/customers/suggest?s=${searchtext ? searchtext : ''}&role=reseller`;
            AuthApis.postApi(url, {
                name: searchtext
            })
                .then((res) => {
                    this.resellerSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 800),

        selectResellerHandler(obj) {
            this.resellerObj = obj.item;
            this.form.reseller_id = obj.item.id;
            this.resellerSuggestions[0].data = [];
        },
        resellerSuggestionsValue(obj) {
            return obj.item.company ? obj.item.company : obj.item.email;
        },

        /**
         *
         * On change Customer
         */
        onChangeCustomer: _.debounce(function (searchtext) {
            // suggest dropdown based on company name
            if (searchtext == null) {
                searchtext = document.getElementById('autosuggest_soldto_customer_input').value;
            }

            this.form.customer_id = '';
            const url = `${Env.baseUrl}/distributor/customers/suggest?s=${searchtext ? searchtext : ''}&role=customer`;
            AuthApis.postApi(url, {
                name: searchtext
            })
                .then((res) => {
                    this.customerSuggestions[0].data = res.data.payload;
                })
                .catch((err) => {
                    console.log(err);
                });
        }, 800),

        selectCustomerHandler(obj) {
            this.customerObj = obj.item;
            this.form.customer_id = obj.item.id;
            this.customerSuggestions[0].data = [];
        },
        customerSuggestionsValue(obj) {
            return obj.item.fname + ' ' + obj.item.lname;
        }
    }
};
</script>
